<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>通用配置</span>
          <el-button v-permisaction="['config:common-config:add']" size="mini" style="margin-left: 10px" type="primary" @click="exportJson()">导出JSON</el-button>
          <!--          <el-button v-permisaction="['config:common-config:add']" size="mini" style="margin-left: 10px" type="primary" @click="uploadCdn()">同步到S3</el-button>-->
          <syncVersion :in-method="updateCdn" />
          <clear-cache-apply />
          <sync-data />
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane v-for="(comm, i) in commonConfig" :key="i" :label="comm.label" :name="comm.value">
            <el-button v-permisaction="['config:common-config:add']" style="margin-bottom: 10px" type="primary" @click="add(comm.value)">+</el-button>
            <el-button v-permisaction="['config:common-config:add']" style="margin-bottom: 10px" type="primary" @click="onSubmit(comm.value)">保存</el-button>
            <el-form :inline="true" class="demo-form-inline">
              <el-row v-for="(item, index) in formData[comm.value]" :key="index">
                <el-form-item label="Key">
                  <el-input v-model.trim="item.title" style="width: 250px;" placeholder="Key" />
                </el-form-item>
                <el-form-item label="Value">
                  <el-select v-if="item.title === 'CooperativeTokenTranType'" v-model="item.content" style="width: 250px;" placeholder="请选择">
                    <el-option v-for="column in cooperativeTokenTranType" :key="column.value" :label="column.label" :value="column.value" />
                  </el-select>
                  <el-input v-else v-model="item.content" style="width: 250px;" placeholder="Value" />
                </el-form-item>
                <el-form-item label="备注">
                  <el-input v-model="item.memo" style="width: 250px;" placeholder="备注" />
                </el-form-item>
                <el-form-item>
                  <el-button v-permisaction="['config:common-config:del']" type="danger" @click="del(item.id, comm.value)">删除</el-button>
                </el-form-item>
              </el-row>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { delBasicCfg, getBasicCfg, updateBasicCfg, updateCdn } from '@/api/config/sys-cfg'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncVersion from '@/components/SyncVersion/index.vue'
import SyncData from '@/components/syncData/index.vue'
export default {
  name: 'CommonConfig',
  components: { SyncData, SyncVersion, ClearCacheApply },
  data() {
    return {
      activeName: 'basic',
      commonConfig: [{
        label: '基础配置',
        value: 'basic'
      }, {
        label: '游戏配置',
        value: 'Game'
      }, {
        label: '安卓配置',
        value: 'android'
      }, {
        label: 'ios配置',
        value: 'ios'
      }, {
        label: '体力广告配置',
        value: 'getSpinAd'
      }, {
        label: 'URL地址配置',
        value: 'Url'
      }, {
        label: '广告奖励配置',
        value: 'adReward'
      }, {
        label: '好友配置',
        value: 'FriendProp'
      }, {
        label: '新手引导配置',
        value: 'BeginnerReward'
      }, {
        label: '排行榜配置',
        value: 'Rank'
      }, {
        label: '偷对象配置',
        value: 'richestKing'
      }, {
        label: '金币配置',
        value: 'onoff'
      }, {
        label: '首冲配置',
        value: 'FirstPay'
      }, {
        label: 'AbTest配置',
        value: 'AbTest'
      }, {
        label: '订阅会员配置',
        value: 'SubVip'
      }, {
        label: '活动配置',
        value: 'Activity'
      }],
      formData: {
        basic: [],
        getSpinAd: [],
        android: [],
        Url: [],
        adReward: [],
        FriendProp: [],
        BeginnerReward: [],
        Rank: [],
        ios: [],
        richestKing: [],
        Game: [],
        onoff: [],
        FirstPay: [],
        AbTest: [],
        SubVip: [],
        Activity: []
      },
      cooperativeTokenTranType: [
        { 'label': '金币', value: '14' },
        { 'label': '体力', value: '15' }
      ]
    }
  },
  created() {
    this.getTables(this.activeName)
  },
  methods: {
    updateCdn,
    add(name) {
      this.formData[name].unshift({
        item: name,
        title: '',
        content: '',
        memo: ''
      })
    },
    onSubmit(name) {
      for (const i in this.formData[name]) {
        const _data = this.formData[name][i]
        if (_data.title === '') {
          this.msgError('key不能为空')
          return
        }
        _data.title = _data.title.replace(/\s/g, '')
        if (_data.content === '') {
          // this.msgError('value不能为空')
          // return
        }
        if (_data.memo === '') {
          this.msgError('备注不能为空')
          return
        }
      }
      const data = JSON.stringify(this.formData[name])
      // console.log(data)
      updateBasicCfg({ name: name, data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables(name)
          this.uploadCdn()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables(name) {
      getBasicCfg({ name: name }).then(res => {
        if (res.code === 200) {
          this.formData[name] = res.data
        } else {
          this.msgError(res.msg)
        }
      })
    },
    del(id, name) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delBasicCfg({ id: id }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables(name)
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    handleClick(tab, event) {
      console.log(tab.name, event)
      this.activeName = tab.name
      this.getTables(tab.name)
    },
    exportJson() {
      window.open(process.env.VUE_APP_BASE_API + '/api/v1/export/exportBasicJson')
    },
    uploadCdn() {
      this.$confirm('请检查数据是否有误，该操作将同步到S3最新版本?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '再看看',
        type: 'warning'
      }).then(() => {
        updateCdn().then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables(this.activeName)
            // this.updateStatic()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    }
    // updateStatic() {
    //   this.$confirm('是否同步静态配置到S3?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '再看看',
    //     type: 'warning'
    //   }).then(() => {
    //     makeStaticJson().then(res => {
    //       if (res.code === 200) {
    //         this.msgSuccess('更新成功')
    //       } else {
    //         this.msgError(res.msg)
    //       }
    //     })
    //   })
    // }
  }
}
</script>

<style scoped>
</style>
